import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4 sm:pr-2" }
const _hoisted_2 = { class: "relative intro-x" }
const _hoisted_3 = {
  class: "relative hidden sm:block",
  id: "profileSection"
}
const _hoisted_4 = {
  class: "relative text-slate-600 sm:hidden",
  href: ""
}
const _hoisted_5 = { class: "absolute right-0 z-10 mt-[3px]" }
const _hoisted_6 = { class: "w-[450px] p-5 box" }
const _hoisted_7 = { class: "mb-2 font-medium" }
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = {
  href: "",
  class: "flex items-center"
}
const _hoisted_10 = { class: "flex items-center justify-center w-8 h-8 rounded-full bg-success/20 dark:bg-success/10 text-success" }
const _hoisted_11 = { class: "ml-3" }
const _hoisted_12 = {
  href: "",
  class: "flex items-center mt-2"
}
const _hoisted_13 = { class: "flex items-center justify-center w-8 h-8 rounded-full bg-pending/10 text-pending" }
const _hoisted_14 = { class: "ml-3" }
const _hoisted_15 = {
  href: "",
  class: "flex items-center mt-2"
}
const _hoisted_16 = { class: "flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 dark:bg-primary/20 text-primary/80" }
const _hoisted_17 = { class: "ml-3" }
const _hoisted_18 = { class: "mb-2 font-medium" }
const _hoisted_19 = { class: "mb-5" }
const _hoisted_20 = { class: "w-8 h-8 image-fit" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "ml-3" }
const _hoisted_23 = { class: "w-48 ml-auto text-xs text-right truncate text-slate-500" }
const _hoisted_24 = { class: "mb-2 font-medium" }
const _hoisted_25 = { class: "w-8 h-8 image-fit" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "ml-3" }
const _hoisted_28 = { class: "w-48 ml-auto text-xs text-right truncate text-slate-500" }
const _hoisted_29 = { class: "mb-5 font-medium" }
const _hoisted_30 = { class: "relative flex-none w-12 h-12 mr-1 image-fit" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 right-0 w-3 h-3 border-2 border-white rounded-full bg-success dark:border-darkmode-600" }, null, -1)
const _hoisted_33 = { class: "ml-2 overflow-hidden" }
const _hoisted_34 = { class: "flex items-center" }
const _hoisted_35 = { class: "mr-5 font-medium truncate" }
const _hoisted_36 = { class: "ml-auto text-xs text-slate-400 whitespace-nowrap" }
const _hoisted_37 = { class: "w-full truncate text-slate-500 mt-0.5" }

import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import LayoutSwitcher from "../../base-components/LayoutSwitcher";
import ThemeSettings from "@/components/ThemeSettings/ThemeSettings.vue";
import Lucide from "../../base-components/Lucide";
import Breadcrumb from "../../base-components/Breadcrumb";
import { FormInput } from "../../base-components/Form";
import { Menu, Popover } from "../../base-components/Headless";
import { getToolTips } from "@/services/backend/backend.service";
import _ from "lodash";
import { TransitionRoot } from "@headlessui/vue";
import fakerData from "../../utils/faker";
import { loadMessages } from '../../services/translation/translation.service';
import { Labels } from '../constants.enum';
import introJs from "intro.js";
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  props: {
  layout: String,
},
  setup(__props) {

const props = __props

const { t } = useI18n();


const store = useStore();
const rightDiv = ref("");
const searchDropdown = ref(false);
const showSearchDropdown = () => {
  searchDropdown.value = true;
};
const router = useRouter();
const route = useRoute();
const breadcrumb = ref("");
const key = ref(0);
const label = ref(localStorage.getItem("breadcrumb"));
const toolTipsData = ref([]);
const toolTipsDetail = ref([]);
const translatedToolTips = ref({});

onMounted(async () => {

  const res = await getToolTips();
  toolTipsData.value = res.data?.response?.records?.master || [];
  toolTipsDetail.value = res.data?.response?.records?.detail || [];

  // Extract keys to translate from master
  const keysToTranslateMaster = toolTipsData.value
    .map(item => item.mapper1_id_value)
    .filter(Boolean);

  // Extract keys to translate from detail
  const keysToTranslateDetail = toolTipsDetail.value
    .map(d => d.description)
    .filter(Boolean);

  const messages = await loadMessages([...keysToTranslateMaster, ...keysToTranslateDetail]);
  translatedToolTips.value = { ...messages };

  const data = [
    Labels.managementId,
    Labels.searchId,
    Labels.pagesId,
    Labels.mailSettingsId,
    Labels.usersPermissionsId,
    Labels.transactionsReportId,
    Labels.usersId,
    Labels.productsId,
    Labels.notificationsId,
    Labels.welcomeId,
    Labels.welcomeTitleId,
    Labels.notificationsTitleId,
    Labels.notificationsIntroId,
    Labels.settingsIntroId,
    Labels.searchIntroId,
    Labels.languageIntroId,
    Labels.currencyIntroId,
    Labels.profileMenuIntroId,
    Labels.profileMenuTitleId,
    Labels.nextId,
    Labels.previousId,
    Labels.finishId,
    Labels.subMainId,
    Labels.subPlatformId,
    Labels.subPlatformTitleId,
    Labels.subMainTitleId,
  ];

  await loadMessages(data);
});

window.addEventListener("message", (event) => awaitEvent(event), false);
async function awaitEvent(event) {
  if (event.data == "menuChange") {
    label.value = localStorage.getItem("breadcrumb");
  }
}


breadcrumb.value = capitalizeFirstLetter(route.path.split("/").pop());
setBreadcrumb(breadcrumb);

router.afterEach((to: any, from: any) => {
  breadcrumb.value = capitalizeFirstLetter(to.path.split("/").pop());
  setBreadcrumb(breadcrumb);
});

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function setBreadcrumb(breadcrumb: any) {
  const isNumeric = Number(breadcrumb.value);
  if (!isNaN(isNumeric)) {
    breadcrumb.value = capitalizeFirstLetter("html-preview");
  }
}

function calculatePlacement() {
  if (window.innerWidth > 600) {
    return "bottom-end";
  } else {
    ("bottom-start");
  }
}

function getBreadcrumbRoute() {
  return "/management";
}

const hideSearchDropdown = () => {
  searchDropdown.value = false;
};

function goToInbox() {
  router.push("/management/inbox");
}
function selectTheme(theme: string) {
  store.dispatch("setTheme", theme);

  if (document.getElementById("subapp-viewport-platform") == null) {
    location.reload();
  }

  const targetOrigin = window.location.origin;
  var element = document.getElementById("subapp-viewport");
  var styles = rightDiv.value.getElementsByTagName("style");
  removeStyles(styles);

  window.postMessage("layout change", targetOrigin);
}

function removeStyles(styles: any) {
  var elementstoRemove: any[] = [];
  styles.forEach((element: { [x: string]: any; }) => {
    if (element["Symbol(style-modified-qiankun)"]) {
      //element.remove();
      elementstoRemove.push(element);
    }
  });
  elementstoRemove.forEach((element) => {
    element.remove();
  });
}
function goToDashboard() {
  router.push("/management");
}

function startHints() {
  const stepsArray = toolTipsData.value
    .map(item => {
      const el = document.getElementById(item.mapper2_id);

      // Title from master
      const titleText = translatedToolTips.value[item.mapper1_id_value] || item.mapper1_id_value;

      // Intro from matching detail
      const detailMatch = toolTipsDetail.value.find(d => d.value === item.mapper1_id_value);
      const introText = detailMatch
        ? translatedToolTips.value[detailMatch.description] || detailMatch.description
        : titleText; // fallback to master
        console.log({ titleText, introText, next: Labels.nextId, prev: Labels.previousId, done: Labels.finishId });

      return el
        ? { element: el, title: t(titleText), intro: t(introText) }
        : null;
    })
    .filter(Boolean);

  if (!stepsArray.length) return console.warn("No valid steps found");

  introJs()
    .setOptions({
      steps: stepsArray,
      showProgress: true,
      showBullets: false,
      exitOnOverlayClick: false,
      nextLabel: t(Labels.nextId),
      prevLabel: t(Labels.previousId),
      doneLabel: t(Labels.finishId),
    })
    .start();
}



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    id: "topbar",
    class: _normalizeClass([
    'sm:grid md:flex items-center relative border-b justify-between ',
    {
      'h-[67px] border-slate-200 z-[50]': __props.layout === 'rubick',
    },
    {
      'z-[50] md:z-[52] mt-[70px] md:mt-0 h-full h-[70px] py-4 md:py-0 md:h-[65px] border-white/[0.08] md:mt-0 md:-mx-0 px-4 md:border-b-0 md:inset-x-0 md:top-0 md:px-10 md:pt-10 md:bg-gradient-to-b md:from-slate-100 md:to-transparent dark:md:from-darkmode-700':
        __props.layout === 'enigma',
      'before:content-[\'\'] before:absolute before:h-[65px] before:inset-0 before:top-0 before:mx-7 before:bg-primary/30 before:mt-3 before:rounded-xl before:hidden before:md:block before:dark:bg-darkmode-600/30':
        __props.layout === 'enigma',
      'after:content-[\'\'] after:absolute after:inset-0 after:h-[65px] after:mx-3 after:bg-primary after:mt-5 after:rounded-xl after:shadow-md after:hidden after:md:block after:dark:bg-darkmode-600':
        __props.layout === 'enigma',
    },
    {
      'z-[50] h-[70px] border-white/[0.08] mt-12 md:-mt-5 -mx-3 sm:-mx-8 px-3 sm:px-8 md:pt-0':
        __props.layout === 'icewall',
    },
    {
      'z-[50] h-[67px] border-slate-200': __props.layout === 'tinker',
    },
  ])
  }, [
    _createVNode(_unref(Breadcrumb), {
      light: __props.layout === 'enigma' || __props.layout === 'icewall',
      class: _normalizeClass([
      {
        '-intro-x sm:flex': __props.layout === 'rubick',
      },
      {
        'h-[45px] border-white/[0.08] dark:border-white/[0.08]  -intro-x':
          __props.layout === 'enigma',
      },
      {
        'h-full border-white/[0.08] -intro-x': __props.layout === 'icewall',
      },
      {
        '-intro-x sm:flex': __props.layout === 'tinker',
      },
    ])
    }, {
      default: _withCtx(() => [
        _createElementVNode("a", {
          class: "cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToDashboard()))
        }, _toDisplayString(_ctx.$t(_unref(Labels).managementId)), 1),
        _createVNode(_unref(Breadcrumb).Link, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goToDashboard()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(label.value), 1)
          ]),
          _: 1
        }),
        (breadcrumb.value != 'Management')
          ? (_openBlock(), _createBlock(_unref(Breadcrumb).Link, {
              key: 0,
              active: true
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(breadcrumb.value), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["light", "class"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(FormInput), {
            type: "text",
            class: _normalizeClass(["border-transparent w-56 shadow-none rounded-full pr-8 transition-[width] duration-300 ease-in-out focus:border-transparent focus:w-72 dark:bg-darkmode-400/70", [
              {
                'bg-slate-300/50': __props.layout === 'rubick',
              },
            ]]),
            placeholder: _ctx.$t(_unref(Labels).searchId),
            onFocus: showSearchDropdown,
            onBlur: hideSearchDropdown
          }, null, 8, ["class", "placeholder"]),
          _createVNode(_unref(Lucide), {
            icon: "Search",
            class: "absolute inset-y-0 right-0 w-5 h-5 my-auto mr-3 text-slate-600 dark:text-slate-500"
          })
        ]),
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_unref(Lucide), {
            icon: "Search",
            class: "w-5 h-5 dark:text-slate-500"
          })
        ]),
        _createVNode(_unref(TransitionRoot), {
          as: "template",
          show: searchDropdown.value,
          enter: "transition-all ease-linear duration-150",
          enterFrom: "mt-5 invisible opacity-0 translate-y-1",
          enterTo: "mt-[3px] visible opacity-100 translate-y-0",
          entered: "mt-[3px]",
          leave: "transition-all ease-linear duration-150",
          leaveFrom: "mt-[3px] visible opacity-100 translate-y-0",
          leaveTo: "mt-5 invisible opacity-0 translate-y-1"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(_unref(Labels).pagesId)), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_unref(Lucide), {
                        icon: "Inbox",
                        class: "w-4 h-4"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(_unref(Labels).mailSettingsId)), 1)
                  ]),
                  _createElementVNode("a", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_unref(Lucide), {
                        icon: "Users",
                        class: "w-4 h-4"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t(_unref(Labels).usersPermissionsId)), 1)
                  ]),
                  _createElementVNode("a", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_unref(Lucide), {
                        icon: "CreditCard",
                        class: "w-4 h-4"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(_unref(Labels).transactionsReportId)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t(_unref(Labels).usersId)), 1),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_).take(_unref(fakerData), 4), (faker, fakerKey) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: fakerKey,
                      href: "",
                      class: "flex items-center mt-2"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("img", {
                          alt: "Midone Tailwind HTML Admin Template",
                          class: "rounded-full",
                          src: faker.photos[0]
                        }, null, 8, _hoisted_21)
                      ]),
                      _createElementVNode("div", _hoisted_22, _toDisplayString(faker.users[0].name), 1),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(faker.users[0].email), 1)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(_unref(Labels).productsId)), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_).take(_unref(fakerData), 4), (faker, fakerKey) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: fakerKey,
                    href: "",
                    class: "flex items-center mt-2"
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        alt: "Midone Tailwind HTML Admin Template",
                        class: "rounded-full",
                        src: faker.images[0]
                      }, null, 8, _hoisted_26)
                    ]),
                    _createElementVNode("div", _hoisted_27, _toDisplayString(faker.products[0].name), 1),
                    _createElementVNode("div", _hoisted_28, _toDisplayString(faker.products[0].category), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ]),
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'exclamation'],
        onClick: _cache[2] || (_cache[2] = ($event: any) => (startHints())),
        "data-intro": "Hello step one!",
        class: "cursor-pointer w-5 h-5 dark:text-slate-500"
      }),
      _createVNode(_unref(Popover), { class: "intro-x" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Popover).Button, {
            class: _normalizeClass(["relative outline-none block before:content-[''] before:w-[8px] before:h-[8px] before:rounded-full before:absolute before:top-[-2px] before:right-0 before:bg-danger", {
            'text-slate-600': __props.layout === 'rubick',
            'text-white/70':
              __props.layout === 'enigma' || __props.layout === 'icewall',
          }])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Lucide), {
                icon: "Bell",
                class: "w-5 h-5 dark:text-slate-500",
                id: "menuButton"
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(Popover).Panel, {
            as: 'div',
            placement: calculatePlacement(),
            class: "w-[280px] sm:w-[350px] p-5 mt-2"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t(_unref(Labels).notificationsId)), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_).take(_unref(fakerData), 5), (faker, fakerKey) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: goToInbox,
                  key: fakerKey,
                  class: _normalizeClass([
            'cursor-pointer relative flex items-center',
            { 'mt-5': fakerKey },
          ])
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      alt: "Midone Tailwind HTML Admin Template",
                      class: "rounded-full",
                      src: faker.photos[0]
                    }, null, 8, _hoisted_31),
                    _hoisted_32
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("a", _hoisted_35, _toDisplayString(faker.users[0].name), 1),
                      _createElementVNode("div", _hoisted_36, _toDisplayString(faker.times[0]), 1)
                    ]),
                    _createElementVNode("div", _hoisted_37, _toDisplayString(faker.news[0].shortContent), 1)
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["placement"])
        ]),
        _: 1
      }),
      _createVNode(ThemeSettings, {
        id: "settings",
        layout: __props.layout,
        onSelectTheme: selectTheme
      }, null, 8, ["layout"])
    ])
  ], 2))
}
}

})